<template>
  <div class="dev-toggle" v-if="hasPermission('DeveloperTools')">
    <label><input type="checkbox" :checked="devState.active" @change="setDevModeActive()" /><span>DEV</span></label>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      devState: state => state.dev
    }),

    ...mapGetters('auth', ['hasPermission', 'hasRole'])
  },

  methods: {
    ...mapActions('dev', ['setActive']),

    setDevModeActive () {
      this.setActive(!this.devState.active)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dev-toggle {
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    border-bottom-right-radius: 0.3rem;
    height: 1.2rem;
    background-color: rgba(0,0,0,0.8);
    box-shadow: 0px 0px 8px 2px rgba(0,0,0,1);
    user-select: none;
    z-index: 100;

    label {
      margin: 0;
      padding-right: 0.3rem;
      padding-left: 0.1rem;
      font-size: 0.75rem;
      position: relative;
      bottom: 0.2rem;
      color: #fff;
      cursor: pointer;
      user-select: none;

      span {
        padding-left: 0.2rem;
        position: relative;
        bottom: 0.1rem;
        user-select: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/actions/DevToggle.vue